const lineHeights = {
  normal: 'normal',
  none: 1,
  shorter: 1.25,
  short: 1.375,
  base: 1.5,
  tall: 1.625,
  taller: '2',
  _3: '.75rem',
  _4: '1rem',
  _5: '1.25rem',
  _6: '1.5rem',
  _7: '1.75rem',
  _8: '2rem',
  _9: '2.25rem',
  _10: '2.5rem',
};

export default lineHeights;

export type LineHeightsType = typeof lineHeights;
